import { PAGE_PATH } from 'constants/pagePath'
import {
  ON_RA_LCAR_COST,
  ON_RA_LODGING_TRANSFER,
} from 'constants/specialContract'
import { QnStateProps } from 'states/QnState'
import { isSjDomain, isKsDomain } from 'utils/domain'

/**
 * 特約が一つでも利用可能かどうか判定する。
 * @returns 特約利用が一つでも利用可能であればtrue、それ以外はfalseを返却する。
 */
export const hasSpecialContract = (state: QnStateProps): boolean => {
  return hasRaLodgingTransfer(state) || hasRaLcarCost(state)
}

/**
 * RA宿泊・移動特約が利用可能かどうか判定する。
 * @param state 現在のRakステート
 * @returns RA宿泊・移動特約が利用可能であればtrue, それ以外はfalseを返却する。
 */
export const hasRaLodgingTransfer = (state: QnStateProps): boolean => {
  return (
    (isSjDomain() || isKsDomain()) &&
    state.raLodgingTransfer === ON_RA_LODGING_TRANSFER
  )
}

/**
 * RA代車費用特約が利用可能かどうか判定する。
 * @param state 現在のRakステート
 * @returns RA代車費用特約が利用可能であればtrue, それ以外はfalseを返却する。
 */
export const hasRaLcarCost = (state: QnStateProps): boolean => {
  return (isSjDomain() || isKsDomain()) && state.raLcarCost === ON_RA_LCAR_COST
}

/**
 * 特約利用が可能なら特約利用画面のURLを、そうでなければ代わりのURLを返却する。
 * 確認画面へ遷移したあとは、状況選択 > 補償画面 となるため、特約利用画面はスキップする。
 * @param state 現在のRakステート
 * @param normalForward 特約利用不可の場合の代わりのURL
 * @returns 遷移先のURL
 */
export const getForwardForSpecialContract = (
  state: QnStateProps,
  normalForward: string
): string => {
  return hasSpecialContract(state) && !state.confirmationChangeType.length
    ? PAGE_PATH.SPECIAL_CONTRACT
    : normalForward
}
